<div class="nv-progress mb-2">
  <div class={{classes}} role="progressbar"></div>
</div>
